import React from 'react';
import { Heart, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: t('home'), href: '#home' },
    { name: t('about'), href: '#about' },
    { name: t('curriculum'), href: '#curriculum' },
    { name: t('testimonials'), href: '#testimonials' },
    { name: t('enroll'), href: '#enroll' }
  ];

  return (
    <footer className="bg-[#141821] border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-[#d4a33a] rounded flex items-center justify-center">
                <Heart className="w-5 h-5 text-white fill-white" />
              </div>
              <span className="text-xl font-semibold">
                <span className="text-[#d4a33a]">Energy</span>
                <span className="text-white">Balance</span>
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-md mb-6">
              {t('footerDesc')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">{t('quickLinks')}</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-[#d4a33a] transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">{t('contact')}</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-gray-400 text-sm">
                <Phone className="w-4 h-4 text-[#d4a33a]" />
                <span>Support Team Mobile: +963988242654</span>
              </li>
              <li className="flex items-start gap-3 text-gray-400 text-sm">
                <MapPin className="w-4 h-4 text-[#d4a33a] mt-0.5" />
                <span>Sweida City - Syria</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} Energy Sacred Union. {t('allRightsReserved')}
            </p>
            <div className="flex gap-6">
              <a href="#privacy" className="text-gray-400 hover:text-[#d4a33a] text-sm transition-colors duration-200">
                {t('privacyPolicy')}
              </a>
              <a href="#terms" className="text-gray-400 hover:text-[#d4a33a] text-sm transition-colors duration-200">
                {t('termsOfService')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
